module.exports = __webpack_public_path__ + "static/selim-goksin-340c15c498af65db81495effd34bb9e1.png";